// Sección de canales de comunicación en Admin (Dimensiones).
// Catálogo unificado usado en interacciones de CRM, toques y hitos de prospección.

import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { FaRegEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";

const BASE = process.env.REACT_APP_API_BASE || "http://localhost/twinpack/php";

const CanalesAdmin = () => {
    const [canales, setCanales] = useState([]);
    const [newCanal, setNewCanal] = useState("");

    useEffect(() => {
        fetchCanales();
    }, []);

    const fetchCanales = async () => {
        try {
            const res = await fetch(`${BASE}/buscar_canales.php`);
            const data = await res.json();
            setCanales(data);
        } catch {
            toast.error("Error al cargar canales");
        }
    };

    const handleAdd = async () => {
        const nombre = newCanal.trim();
        if (!nombre) return;
        try {
            const res = await fetch(`${BASE}/guardar_canal.php`, {
                method: "POST",
                body: new URLSearchParams({ nombre }),
            });
            const data = await res.json();
            if (data.ok) {
                toast.success("Canal agregado");
                setNewCanal("");
                fetchCanales();
            } else {
                toast.error(data.error || "Error al agregar");
            }
        } catch {
            toast.error("Error de conexión");
        }
    };

    const handleEdit = async (c) => {
        const newName = prompt("Nuevo nombre para el canal:", c.nombre);
        if (!newName || newName.trim() === c.nombre) return;
        try {
            const res = await fetch(`${BASE}/editar_canal.php`, {
                method: "POST",
                body: new URLSearchParams({ id: c.id, oldName: c.nombre, newName: newName.trim() }),
            });
            const data = await res.json();
            if (data.ok) {
                toast.success("Canal actualizado (y cascadeado en interacciones)");
                fetchCanales();
            } else {
                toast.error(data.error || "Error al editar");
            }
        } catch {
            toast.error("Error de conexión");
        }
    };

    const handleDelete = async (c) => {
        if (!window.confirm(`¿Eliminar el canal "${c.nombre}"?`)) return;
        try {
            const res = await fetch(`${BASE}/eliminar_canal.php`, {
                method: "POST",
                body: new URLSearchParams({ id: c.id }),
            });
            const data = await res.json();
            if (data.ok) {
                toast.success("Canal eliminado");
                fetchCanales();
            } else {
                toast.error(data.error || "Error al eliminar");
            }
        } catch {
            toast.error("Error de conexión");
        }
    };

    return (
        <section>
            <div className="container">
                <div className="container-addbar" style={{ marginTop: "40px" }}>
                    <input
                        type="text"
                        value={newCanal}
                        onChange={(e) => setNewCanal(e.target.value)}
                        placeholder="Nuevo canal de comunicación"
                        onKeyDown={(e) => e.key === "Enter" && handleAdd()}
                    />
                    <button className="searchbar_form_submit" onClick={handleAdd}>
                        Agregar
                    </button>
                </div>

                <div className="categories-table">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Canal</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {canales.map((c) => (
                            <tr key={c.id}>
                                <td>{c.id}</td>
                                <td>{c.nombre}</td>
                                <td>
                                    <div style={{ display: "flex", gap: "1px" }}>
                                        <FaRegEdit
                                            className="action-icon"
                                            onClick={() => handleEdit(c)}
                                            style={{
                                                display: "flex", justifyContent: "center", alignItems: "center",
                                                width: "32px", height: "32px", backgroundColor: "#4893e9",
                                                borderRadius: "5px", cursor: "pointer", marginRight: "7px",
                                            }}
                                        />
                                        <MdDelete
                                            className="action-icon"
                                            onClick={() => handleDelete(c)}
                                            style={{
                                                display: "flex", justifyContent: "center", alignItems: "center",
                                                width: "32px", height: "32px", backgroundColor: "#D9534F",
                                                borderRadius: "5px", cursor: "pointer",
                                            }}
                                        />
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </div>
            </div>
        </section>
    );
};

export default CanalesAdmin;
